<div class="modal custom--modal modal--panel" @slideRight>
  <header class="modal__header">
    <p
      class="t-data t-bold"
      [innerHTML]="config.header"
      data-test-id="existingClientModalHeader"
    ></p>
  </header>

  <section class="modal__body">
    <div class="modal__message">
      <h4
        class="t-bold"
        [innerHTML]="config.warningMessage.header"
        data-test-id="existingClientModalMessageheader"
      ></h4>
      <p
        class="t-data"
        [innerHTML]="config.warningMessage.body"
        data-test-id="existingClientModalMessageBody"
      ></p>
    </div>

    @if (existingClientsData) {
      <div>
        <form-control
          (click)="handleClientSelected()"
          [config]="config.existingClientListConfig"
          [group]="existingClientForm"
          [control]="config.existingClientListConfig"
          [attr.data-test-id]="existingClientForm"
        ></form-control>
      </div>
    }
  </section>

  <footer class="modal__footer">
    <zip-button
      [config]="cancelButtonConfig"
      (click)="onCancel()"
      data-test-id="existingClientCancelButton"
    ></zip-button>

    @if (!!isExistingClientSelected) {
      <zip-button
        [config]="existingClientButtonConfig"
        (click)="onContinue()"
        data-test-id="existingClientContinueButton"
      ></zip-button>
    } @else {
      <zip-button
        [config]="saveButtonConfig"
        [disabled]="!!isSaveButtonDisabled"
        (zipButtonClicked)="onSave()"
        data-test-id="existingClientSaveButton"
      ></zip-button>
    }
  </footer>
</div>
